//Models
PJQ.models.permissions = {};

PJQ.models.permissions.Permission = PJQ.models.BaseModel.extend();

PJQ.models.permissions.ProjectsPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ContactPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DocumentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BidFilerPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CalendarPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SettingsPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrequalPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ResourcePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.TimeCardPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.InvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.UserPermissions = PJQ.models.permissions.Permission.extend();

PJQ.models.permissions.ProjectBasePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.MessagingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrivateMessagingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BidFormPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DrawingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.AttachmentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ProjectContactPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PhotoGalleryPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.RFIPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DailyReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PunchListPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ActionItemPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SubmittalPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReportPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.SchedulePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.BudgetPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CommitmentPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.CommitmentChangeOrderPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrimeContractPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PrimeContractChangeOrderPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.DirectCostPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.PayableInvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ReceivableInvoicePermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.MeetingPermissions = PJQ.models.permissions.Permission.extend();
PJQ.models.permissions.ChangeRequestPermissions = PJQ.models.permissions.Permission.extend();

PJQ.models.permissions.Permissions = PJQ.models.BaseModel.extend({
	idAttribute: "permissionId",
	afterInit: function () {
		this.on('change:userTypeId', function () {
			let userTypeId = this.get('userTypeId');
			if (PJQ.app.session != null && userTypeId != null) {
				this.userType = PJQ.app.session.userTypes.get(userTypeId);
				if (this.userType != null) {
					this.userType.permissions = this;
				}
			}
			else {
				this.userType = null;
			}
		});
	},
	hasPermission: function (permission, options = {}) {
		let result = null;
		let splitPerm = _.bind(function (perm) {
			let parts = perm.split('.'),
				size = _.size(parts),
				stack = this,
				permResult = false;
			_.each(parts, function (part, index) {
				if (stack == null) {
					return;
				}

				if (index + 1 === size) {
					permResult = stack.get(part) === true;
				}
				else {
					stack = stack[part];
				}
			}, this);
			return permResult;
		}, this);
		if (PJQ.helpers.objectHelpers.refinedType(permission) === 'array') {
			_.each(permission, function (perm) {
				if (options.or) {
					result = splitPerm(perm) || (result == null ? false : result);
				}
				else {
					result = splitPerm(perm) && (result == null ? true : result);
				}
			});
		}
		else {
			result = splitPerm(permission);
		}
		return result == null ? false : result;
	},
	parse: function (model) {
		if (model != null) {
			if (PJQ.app.session != null && model.userTypeId != null) {
				this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
			}
			else if (model.userType != null) {
				model.userTypeId = model.userType.id;
				this.userType = model.userType;
			}

			_.each(this.subItems, function (permMap, key) {
				let modelPermissions = model[key];
				if (modelPermissions != null) {
					this[key] = new permMap(modelPermissions);
				}
			}, this);
		}

		return model;
	},
	beforeSave: function () {
		_.each(this.subItems, function (permMap, key) {
			let permissions = this[key];
			if (permissions != null && permissions instanceof PJQ.models.permissions.Permission) {
				this.set(key, permissions.toJSON());
			}
		}, this);
	}
});

PJQ.models.permissions.SystemPermissions = PJQ.models.permissions.Permissions.extend({
	subItems: {
		projects: PJQ.models.permissions.ProjectsPermissions,
		contacts: PJQ.models.permissions.ContactPermissions,
		documents: PJQ.models.permissions.DocumentPermissions,
		bidFiler: PJQ.models.permissions.BidFilerPermissions,
		calendar: PJQ.models.permissions.CalendarPermissions,
		reports: PJQ.models.permissions.ReportPermissions,
		settings: PJQ.models.permissions.SettingsPermissions,
		prequal: PJQ.models.permissions.PrequalPermissions,
		resources: PJQ.models.permissions.ResourcePermissions,
		timeCards: PJQ.models.permissions.TimeCardPermissions,
		invoices: PJQ.models.permissions.InvoicePermissions,
		users: PJQ.models.permissions.UserPermissions
	},
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'permissions',
					value: this.id
				}
			]);
		}
		else if (this.get('id') < 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.get('id')
				},
				{
					endpoint: 'permissions'
				}
			]);
		}
		else if (this.get('id') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'permissions'
				}
			]);
		}
		else if (this.get('userTypeId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes',
					value: this.get('userTypeId')
				},
				{
					endpoint: 'permissions'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'permissions'
			}
		]);
	}
});

PJQ.models.permissions.ProjectPermissions = PJQ.models.permissions.Permissions.extend({
	subItems: {
		base: PJQ.models.permissions.ProjectBasePermissions,
		messaging: PJQ.models.permissions.MessagingPermissions,
		privateMessaging: PJQ.models.permissions.PrivateMessagingPermissions,
		bidForms: PJQ.models.permissions.BidFormPermissions,
		drawings: PJQ.models.permissions.DrawingPermissions,
		attachments: PJQ.models.permissions.AttachmentPermissions,
		projectContacts: PJQ.models.permissions.ProjectContactPermissions,
		photoGallery: PJQ.models.permissions.PhotoGalleryPermissions,
		rfi: PJQ.models.permissions.RFIPermissions,
		dailyReports: PJQ.models.permissions.DailyReportPermissions,
		punchList: PJQ.models.permissions.PunchListPermissions,
		actionItems: PJQ.models.permissions.ActionItemPermissions,
		submittals: PJQ.models.permissions.SubmittalPermissions,
		reports: PJQ.models.permissions.ReportPermissions,
		schedule: PJQ.models.permissions.SchedulePermissions,
		timeCards: PJQ.models.permissions.TimeCardPermissions,
		budget: PJQ.models.permissions.BudgetPermissions,
		commitments: PJQ.models.permissions.CommitmentPermissions,
		commitmentChangeOrders: PJQ.models.permissions.CommitmentChangeOrderPermissions,
		primeContracts: PJQ.models.permissions.PrimeContractPermissions,
		primeContractChangeOrders: PJQ.models.permissions.PrimeContractChangeOrderPermissions,
		directCosts: PJQ.models.permissions.DirectCostPermissions,
		payableInvoices: PJQ.models.permissions.PayableInvoicePermissions,
		receivableInvoices: PJQ.models.permissions.ReceivableInvoicePermissions,
		meetings: PJQ.models.permissions.MeetingPermissions,
		changeRequests: PJQ.models.permissions.ChangeRequestPermissions
	},
	endpoint: function () {
		if (this.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'permissions',
					value: this.id
				}
			]);
		}
		else if (this.get('id') != null && this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'permissions'
				}
			]);
		}
		else if (this.get('id') < 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'permissions'
				}
			]);
		}
		else if (this.get('id') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'contacts',
					value: this.get('id')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'permissions'
				}
			]);
		}
		else if (this.get('userTypeId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'usertypes',
					value: this.get('userTypeId')
				},
				{
					endpoint: 'projects'
				},
				{
					endpoint: 'permissions'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.get('projectId') > 0 ? this.get('projectId') : null
			},
			{
				endpoint: 'permissions'
			}
		]);
	}
});

//Views
PJQ.views.permissions = {};

PJQ.views.permissions.PermissionsEditorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Permissions-Editor'),
		minWidth: 800
	},
	defaultEvents: {
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel'
	},
	renderData: function () {
		return {
			model: this.model,
			project: this.options.project
		};
	},
	afterRender: function () {
		this.permissionEditor = new PJQ.views.permissions.PermissionsEditor({
			el: this.$('.permissions'),
			model: this.model,
			project: this.options.project
		});
	},
	save: function () {
		new PJQ.Loader(this.$('.modal-content'));
		this.permissionEditor.save(_.bind(function () {
			this.removeModal();
			PJQ.notifications.notify.successNotify({
				message: 'Permissions saved'
			});

			if (PJQ.app.session.user != null) {
				let permFn = function () {
					PJQ.app.session.fetchSystemPermissions(function () {
						PJQ.app.navigator.refreshCommands();
					});
				};
				if (this.model.get('id') === PJQ.app.session.user.get('id')) {
					permFn();
				}
				else if (this.model.get('id') == null && this.model.get('userTypeId') === PJQ.app.session.user.get('userTypeId')) {
					permFn();
				}
			}
		}, this));
	},
	cancel: function () {
		this.removeModal();
	}
});

PJQ.views.permissions.PermissionsEditor = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Permissions-Editor'),
		hasTooltips: true
	},
	events: {
		'click .btn-system-permissions-override': 'overrideSystem',
		'click .btn-system-permissions-revert': 'revertSystem',
		'click .btn-project-permissions-override': 'overrideProject',
		'click .btn-project-permissions-revert': 'revertProject'
	},
	beforeFirstRender: function () {
		this.fetchPermissions();
	},
	fetchPermissions: function () {
		if (this.options.project != null) {
			this.fetchProjectPermissions(_.bind(function () {
				this.render();
			}, this));
		}
		else {
			this.fetchSystemPermissions(_.bind(function () {
				this.fetchProjectPermissions(_.bind(function () {
					this.render();
				}, this));
			}, this));
		}
	},
	fetchSystemPermissions: function (callback) {
		this.model.fetchSystemPermissions(_.bind(function (perm) {
			this.systemPermissions = perm;
			if (typeof callback === 'function') {
				callback(perm);
			}
		}, this));
	},
	fetchProjectPermissions: function (callback) {
		if (this.model instanceof PJQ.models.userTypes.UserType) {
			this.model.fetchProjectPermissions(_.bind(function (perm) {
				this.projectPermissions = perm;
				if (typeof callback === 'function') {
					callback(perm);
				}
			}, this));
		}
		else {
			this.model.fetchProjectPermissions(this.options.project ? this.options.project.id : null, _.bind(function (perm) {
				this.projectPermissions = perm;
				if (typeof callback === 'function') {
					callback(perm);
				}
			}, this));
		}
	},
	renderData: function () {
		return {
			model: this.model,
			project: this.options.project,
			systemPermissions: this.systemPermissions,
			projectPermissions: this.projectPermissions,
			hasFeature: this.hasFeature,
			hasApproval: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_APPROVAL_REQUIRED) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_APPROVAL_REQUIRED) : false,
			newAddressBook: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)
		};
	},
	afterRender: function () {
		let fnInit = _.bind(function (permissionEl, permissionModel) {
			let $permissionEl = $(permissionEl),
				permissionKey = $permissionEl.data('permission'),
				permission = permissionModel[permissionKey];
			if (permission != null) {
				new PJQ.Binder($permissionEl, permission, {
					setDefaultValues: true,
					watchElements: [
						'input'
					],
					afterChange: _.bind(function ($perm, attr, val) {
						this.permissionChanged($perm, attr, val);
						permissionModel.isDirty = true;
					}, this)
				});
			}
		}, this);

		if (this.systemPermissions != null) {
			_.each(this.$('.system-permission-container'), function (permissionEl) {
				fnInit(permissionEl, this.systemPermissions);
			}, this);
		}

		if (this.projectPermissions != null) {
			_.each(this.$('.project-permission-container'), function (permissionEl) {
				fnInit(permissionEl, this.projectPermissions);
			}, this);
		}
	},
	hasFeature: function(feature){
		return PJQ.app.session.hasFeature(feature);
	},
	permissionChanged: function ($permission, attr, val) {
		// cascading permissions logic
		let level = $permission.data('level');
		if (level != null) {
			let inputs = $permission.closest('.perm-container').find('input');
			if (val && level > 1) {
				_.each(inputs, function (otherPerm) {
					let $otherPerm = $(otherPerm),
						otherLevel = $otherPerm.data('level');
					if (otherLevel != null && otherLevel < level) {
						$otherPerm.prop('checked', val);
						$otherPerm.trigger('change');
					}
				});
			}
			else if (!val) {
				//don't cascade permissions up if there is another permission at this level still enabled
				if (_.find(inputs, function (otherPerm) {
					let otherAttr = $(otherPerm).data('pBind'),
						otherLevel = $(otherPerm).data('level');
					return otherLevel === level && attr !== otherAttr && $(otherPerm).prop('checked');
				}) != null) {
					return;
				}
				_.each(inputs, function (otherPerm) {
					let $otherPerm = $(otherPerm),
						otherLevel = $otherPerm.data('level');
					if (otherLevel != null && otherLevel > level) {
						$otherPerm.prop('checked', val);
						$otherPerm.trigger('change');
					}
				});
			}
		}
	},
	overrideSystem: function () {
		//To override we have to set the correct values for an overridden permission
		//This will not have an id so it is temporary until saved to the server
		//When it is saved next, it POST to the correct endpoint to create the overridden permissions
		this.systemPermissions.set({
			permissionId: null,
			userTypeId: null,
			id: this.model.get('id'),
			override: true
		});
		this.render();
	},
	revertSystem: function () {
		//To revert we have to delete the overridden permissions if it has been saved to the server already
		//We then have to fetch the inherited permissions
		let fp = _.bind(function () {
			this.fetchSystemPermissions(_.bind(function () {
				this.render();
			}, this));
		}, this);
		if (!this.systemPermissions.isNew()) {
			this.systemPermissions.destroy({
				success: _.bind(function () {
					this.systemPermissions = null;
					fp();
				}, this)
			});
		}
		else {
			fp();
		}
	},
	overrideProject: function () {
		//To override we have to set the correct values for an overridden permission
		//This will not have an id so it is temporary until saved to the server
		//When it is saved next, it POST to the correct endpoint to create the overridden permissions
		this.projectPermissions.set({
			permissionId: null,
			userTypeId: null,
			id: this.model.get('id'),
			projectId: this.options.project ? this.options.project.id : null,
			override: true
		});
		this.render();
	},
	revertProject: function () {
		//To revert we have to delete the overridden permissions if it has been saved to the server already
		//We then have to fetch the inherited permissions
		let fp = _.bind(function () {
			this.fetchProjectPermissions(_.bind(function () {
				this.render();
			}, this));
		}, this);
		if (!this.projectPermissions.isNew()) {
			this.projectPermissions.destroy({
				success: _.bind(function () {
					this.projectPermissions = null;
					fp();
				}, this)
			});
		}
		else {
			fp();
		}
	},
	save: function (callback) {
		let fp = _.bind(function () {
				this.fetchProjectPermissions(_.bind(function () {
					this.render();
				}, this));
			}, this),
			saveP = _.bind(function () {
				if (this.projectPermissions != null && this.projectPermissions.hasChanged()) {
					this.projectPermissions.save(null, {
						success: _.bind(function () {
							if (typeof callback === 'function') {
								callback();
							}
						}, this)
					});
				}
				else {
					if (typeof callback === 'function') {
						callback();
					}
				}
			}, this);
		if (this.systemPermissions != null && this.systemPermissions.hasChanged()) {
			this.systemPermissions.save(null, {
				success: function () {
					saveP();
					fp();
				}
			});
		}
		else {
			saveP();
		}
	}
});
